var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.325,
    height: 9.209,
    "data-name": "icon/Social/Mail/main",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3364fb",
    d: "M13.068 9.209H1.006A.99.99 0 0 1 0 8.239V.97A.99.99 0 0 1 1.006 0h12.062a.99.99 0 0 1 1.006.97v7.27a.99.99 0 0 1-1.006.969M2.011 1.454a.5.5 0 0 0-.393.182.47.47 0 0 0-.107.355.48.48 0 0 0 .186.326L6.723 6.2a.52.52 0 0 0 .628 0l5.027-3.884a.48.48 0 0 0 .185-.326.47.47 0 0 0-.108-.355.516.516 0 0 0-.706-.076L7.037 5.2 2.324 1.56a.5.5 0 0 0-.313-.106",
    "data-name": "Fill 1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h14.325v9.209H0z",
    "data-name": "icon/Social/Mail/main background"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M13.068 9.209H1.006A.99.99 0 0 1 0 8.239V.97A.99.99 0 0 1 1.006 0h12.062a.99.99 0 0 1 1.006.97v7.27a.99.99 0 0 1-1.006.969M2.011 1.454a.5.5 0 0 0-.393.182.47.47 0 0 0-.107.355.48.48 0 0 0 .186.326L6.723 6.2a.52.52 0 0 0 .628 0l5.027-3.884a.48.48 0 0 0 .185-.326.47.47 0 0 0-.108-.355.516.516 0 0 0-.706-.076L7.037 5.2 2.324 1.56a.5.5 0 0 0-.313-.106",
    "data-name": "Fill 1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3364fb",
    d: "M0 0h14.325v9.209H0z",
    "data-name": "Color/Primary"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.33914b239bf80bf2aa290635e2d53ecb.svg";
export { ForwardRef as ReactComponent };